import(/* webpackMode: "eager" */ "/vercel/path0/app/text-formatter/page.tsx");
